module.exports = __webpack_public_path__ + "public/Icons/youtube.png?f9a3ca25";